import { Flex, Icon } from '@chakra-ui/react'
import useStorage from 'hooks/useStorage'
import usePrint from 'pages/Sales/hooks/usePrint'
import { OrderPaymentData } from 'pages/Sales/types'
import ModalDownload from 'pages/Sales/ModalContents/ModalDownload'
import Download from 'components/Icon/Download'
import Printer from 'components/Icon/Printer'

export default function Actions({
    orderPayment
}: {
    orderPayment: OrderPaymentData
}) {
    const { business_variables } = useStorage()
    const { printHandler, isLoading } = usePrint(
        orderPayment.id,
        orderPayment.proof_payment
    )

    const toDownload =
        orderPayment.proof_payment === 1 || orderPayment.proof_payment === 2
    const xml_name = toDownload ? orderPayment.sunat_voucher?.xml_name : ''
    const print_sale_note = business_variables.find(
        v => v.code === '001'
    )?.value

    return (
        <Flex justifyContent="center">
            <ModalDownload
                element={click => (
                    <Icon
                        as={Download}
                        display="block"
                        fill="dark"
                        onClick={click}
                        mr="2"
                        cursor="pointer"
                        pointerEvents={toDownload && xml_name ? 'auto' : 'none'}
                        opacity={toDownload ? '1' : '.6'}
                    />
                )}
                onDone={() => null}
                filename={xml_name}
            />
            <Icon
                as={Printer}
                display="block"
                fill="dark"
                onClick={printHandler}
                cursor="pointer"
                pointerEvents={
                    isLoading ||
                    orderPayment.code.length === 0 ||
                    (print_sale_note == '0' && orderPayment.proof_payment == 4)
                        ? 'none'
                        : 'auto'
                }
                opacity={
                    isLoading ||
                    orderPayment.code.length === 0 ||
                    (print_sale_note == '0' && orderPayment.proof_payment == 4)
                        ? '.6'
                        : '1'
                }
            />
        </Flex>
    )
}
